import { PlaceholderProps } from "components/Placeholder/placeholder.props";
import { extractHiddenBlock, normalizeStyles } from "../../utils/styles";
import { AppPlaceholder } from "@sitecore-content-sdk/nextjs";
import React, { JSX } from "react";
import componentMap from ".sitecore/component-map";

const Default = (props: PlaceholderProps): JSX.Element => {
  console.log("---->[Placeholder] Component");

  const { page, params, placeholderKey, rendering } = props;

  const phKey = `${placeholderKey || "placeholder"}-${params.DynamicPlaceholderId}`;
  const paddingPageBuilder = page.mode.isEditing ? "p-5" : "p-0";
  const hiddenBlockStyles = extractHiddenBlock(params?.GridParameters);
  const componentStyles = normalizeStyles(
    `${params?.styles || ""} ${paddingPageBuilder} ${hiddenBlockStyles}`,
  );
  return (
    <div className={componentStyles}>
      <AppPlaceholder
        name={phKey}
        rendering={rendering}
        page={page}
        componentMap={componentMap}
      />
    </div>
  );
};

const Content = (props: PlaceholderProps): JSX.Element => {
  return <Default {...props} placeholderKey={"placeholder"} />;
};

const Hero = (props: PlaceholderProps): JSX.Element => {
  return <Default {...props} placeholderKey={"top-primary-placeholder"} />;
};

const SolutionHero = (props: PlaceholderProps): JSX.Element => {
  return (
    <Default {...props} placeholderKey={"top-primary-solution-placeholder"} />
  );
};

export { Default, Content, Hero, SolutionHero };
